<template>
  <div>
    <ItemGroup
      :class="['fapi-form-item-group', 'fapi-form-item-group-' + itemGroup.id]"
      v-for="itemGroup in itemGroups"
      v-bind:key="itemGroup.id + '-group'"
      :first="itemGroup.id === 0"
      :itemGroup="itemGroup"
      :currency="currency"
      :formResource="formResource"
      :selectedItems="selectedItems"
      :isVatPayer="isVatPayer"
      :allowedPeriods="allowedPeriods"
      :selectedPeriod="selectedPeriod"
      @periodChanged="$emit('periodChanged', $event)"
      @itemDataChanged="$emit('itemDataChanged', $event)"
      @currencyChanged="$emit('currencyChanged', $event)"
    >
    </ItemGroup>

    <BasicBlock
      v-if="this.orderBumps.length > 0"
      :title="$t('order_bump.block.title')"
      :orderBump="true"
    >
      <OrderBump
        v-for="(orderBump, index) in orderBumps"
        v-bind:key="orderBump.id + '-' + index + '-order-bump'"
        :formResource="formResource"
        :currency="currency"
        :showPricesIncludingVat="formResource.show_prices_including_vat"
        :orderBump="orderBump"
        @orderBumpChanged="$emit('orderBumpChanged', $event)"
      ></OrderBump>
    </BasicBlock>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import ItemGroup from "@/components/Form/Items/ItemGroup.vue";
import FormResource from "@/module/Form/Resources/FormResource";
import SelectedItem from "@/module/Form/SelectedItem";
import OrderBump from "@/components/Form/Items/OrderBump.vue";
import BasicBlock from "@/components/Form/BasicBlock.vue";
import { isStringOrNull } from "@/module/ComponentPropsValidations/validations";
import FormOrderBump from "@/module/FormOrderBump";
import FormItemGroup from "@/module/FormItemGroup";

export default Vue.extend({
  name: "ItemGroups",

  components: { BasicBlock, OrderBump, ItemGroup },

  props: {
    itemGroups: {
      type: Array as PropType<Array<FormItemGroup>>,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    formResource: {
      type: Object as PropType<FormResource>,
      required: true,
    },
    selectedItems: {
      type: Array as PropType<Array<SelectedItem>>,
      required: true,
    },
    orderBumps: {
      type: Array as PropType<Array<FormOrderBump>>,
      required: true,
    },
    isVatPayer: {
      type: Boolean,
      required: true,
    },
    allowedPeriods: {
      type: Array as PropType<Array<string>>,
      required: true,
    },
    selectedPeriod: {
      required: true,
      validator: isStringOrNull,
    },
  },
});
</script>
